// TODO: add flow types

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { autobind } from 'core-decorators';
import { Breadcrumb } from '../redesign/Breadcrumb';
import { getUrlParameterByName } from '../../utils/url';

import { bookingRequestShape } from '../../utils/PropTypes';
import tracking from '../../tracking';

@inject('authStore')
export default class BreadcrumbLink extends Component {
  static propTypes = {
    path: PropTypes.string,
    text: PropTypes.string,
    bookingRequest: bookingRequestShape,
  };

  static contextTypes = {
    breadcrumbsInfo: PropTypes.array,
    setBreadcrumbTitle: PropTypes.func,
  };

  // TUICUNIT-3782
  @autobind onLogoutClick() {
    this.props.authStore.logout().then(() => {
      // We make a hard reset here, to be sure, we don't have any states saved in some stores
      // or anywhere else
      globalThis.location.href = this.props.authStore.user.backLink
        ? this.props.authStore.user.backLink
        : '/login';
    });
  }

  render() {
    const { path, text, bookingRequest } = this.props;
    const { setBreadcrumbTitle } = this.context;
    if (setBreadcrumbTitle) setBreadcrumbTitle(path, text, bookingRequest);

    const previousItem = this.context.breadcrumbsInfo.slice(-2)[0];

    // TUICUNIT-3782
    const shouldDoDashboardRedirect =
      previousItem.text === 'Meine Reise' &&
      this.props.authStore?.user?.backLink;

    // When entering a page from a link with parameters including backLink,
    // the authStore.user.backLink in the props might not be set yet, so we check the URL
    // parameters again here. (OM-2131)
    const backLink =
      this.props.authStore?.user?.backLink ?? getUrlParameterByName('backLink');

    const backlinkPreferenceUrls = [
      'buchungsdetails/an-und-abreise',
      'buchungsdetails/zusatzleistungen',
      'buchungsdetails/reisepreis',
      'buchungsdetails/reiseunterlagen',
      'buchungsdetails/reiseversicherung',
      'buchungsdetails/vip-tarif',
      // Required to support new MyTrips based manifest - see OM-3420
      'manifest'
    ];

    // Is the current path matching one that should prefer the provided backlink?
    const isPathWithBacklinkPreference = backlinkPreferenceUrls.some((url) =>
      path.includes(url)
    );

    const href= isPathWithBacklinkPreference ? backLink : previousItem.path;

    return (
      <Breadcrumb
        backAnchor={{
          href,
          onClick: (event) => {
            tracking.click('breadcrumb.link.' + previousItem.text);
            if (shouldDoDashboardRedirect) {
              event.preventDefault();
              return this.onLogoutClick();
            }
            // this is needed as we might use distinct hosts e.g. on test-systems
            if (preferBackLink) {
              event.preventDefault();
              globalThis.location.assign(backLink);
            }
          }
        }}
      >
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </Breadcrumb>
    );
  }
}
